import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'
import moment from 'moment'

const urlConsultaDiarias = '/service/contabilidade/dotacao/'

class ConsultaRestosPagar extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
        const adms = config.adms && config.adms.length > 0 ? config.adms.join() : null
        this.state = {
            adms: adms,
        }
    }

    consultar(filtro) {
        let data = {
            administracao: filtro.administracao.length > 0 ? filtro.administracao.map(e => e.value).join() : this.state.adms,
            exercicioInicial: filtro.exercicioInicial ? filtro.exercicioInicial : null,
            exercicioFinal: filtro.exercicioFinal ? filtro.exercicioFinal : null,
            numeroEmpenhoInicial: filtro.numeroEmpenhoInicial ? filtro.numeroEmpenhoInicial : null,
            numeroEmpenhoFinal: filtro.numeroEmpenhoFinal ? filtro.numeroEmpenhoFinal : null,
            dataEmpenhoInicial: filtro.dataEmpenhoInicial ? moment(filtro.dataEmpenhoInicial).format() : null,
            dataEmpenhoFinal: filtro.dataEmpenhoFinal ? moment(filtro.dataEmpenhoFinal).format() : null,
            dataVencimentoInicial: filtro.dataVencimentoInicial ? moment(filtro.dataVencimentoInicial).format() : null,
            dataVencimentoFinal: filtro.dataVencimentoFinal ? moment(filtro.dataVencimentoFinal).format() : null,
            recurso: filtro.recurso.length !== 0 ? filtro.recurso.map(e => e.value).join() : null,
            destinacao: filtro.destinacao.length !== 0 ? filtro.destinacao.map(e => e.value).join() : null,
        }
        return this.conex.post(urlConsultaDiarias + 'consultaRestosPagar/', JSON.stringify(data))
    }
}

export default ConsultaRestosPagar
